import { render, staticRenderFns } from "./CoverBlock.vue?vue&type=template&id=38b0337a&scoped=true&"
import script from "./CoverBlock.vue?vue&type=script&lang=js&"
export * from "./CoverBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoverBlock.vue?vue&type=style&index=0&id=38b0337a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b0337a",
  null
  
)

export default component.exports